import React from 'react';
import Modal from '../../../../components/Modal';
import { Button } from '../../../../components';
import { useDutyRoster } from '../DutyRosterContext';

const AddTeamModal = () => {
    const { addTeamOpen, newTeamName, setNewTeamName, savingTeam, closeAddTeam, submitAddTeam } = useDutyRoster();
    return (
        <Modal
            isOpen={addTeamOpen}
            onClose={closeAddTeam}
            title="Add team"
            maxWidth="max-w-[420px]"
        >
            <div className="space-y-4 pt-1">
                <div>
                    <label className="block text-[11px] font-extrabold uppercase tracking-wider text-[#475569] dark:text-gray-400 mb-1.5">Team name</label>
                    <input
                        type="text"
                        autoFocus
                        value={newTeamName}
                        onChange={(e) => setNewTeamName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') submitAddTeam(); }}
                        placeholder="e.g. Weekend Care Team"
                        className="w-full px-3 py-2.5 rounded-lg border border-[#E2E8F0] dark:border-gray-700 dark:bg-[#31373f] dark:text-gray-200 focus:border-blue-500 outline-none text-[13px]"
                    />
                    <p className="mt-1.5 text-[11px] text-[#94A3B8] dark:text-gray-500">
                        The team is created empty — use “Manage teams” to move staff into it.
                    </p>
                </div>

                <div className="flex items-center justify-end gap-2.5 pt-1">
                    <Button type="button" variant="secondary" onClick={closeAddTeam} disabled={savingTeam}>
                        Cancel
                    </Button>
                    <Button type="button" variant="primary" onClick={submitAddTeam} loading={savingTeam}>
                        Create
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AddTeamModal;
